export const roundFloat = (value: number, nbDigits?: number): number => {
  if (!nbDigits) {
    nbDigits = 5;
  }

  return Math.round(value * 10 ** nbDigits) / 10 ** nbDigits;
};
